module.exports = __webpack_public_path__ + "img/ATTACHMENT.a597f883.svg";